import uploadsscholarshipspagebannerbgimageoutputJpg from "$lib/data/generated/uploads/scholarships/PageBanner/bgImage/output.jpg?as=run";

export const uploads = {
  "uploads/scholarships/PageBanner/bgImage/output.jpg": uploadsscholarshipspagebannerbgimageoutputJpg
};